export default __webpack_public_path__ + "static/media/mixedFraction.75ba5d79.svg";